export enum GoogleAdType {
  SEARCH = 'search',
  DISPLAY = 'display',
  SHOPPING = 'shopping',
  OVERALL = 'overall',
  NONE = 'none'
}
